module.exports = __webpack_public_path__ + "static/35-25834cfc0df651f3e4f22d872f06b67b.jpg";